var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 13.539a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356a.49.49 0 0 1 .356-.143h15q.213 0 .356.143a.48.48 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.144zm0-4.77a.48.48 0 0 1-.356-.144A.49.49 0 0 1 0 8.268q0-.212.144-.356A.49.49 0 0 1 .5 7.77h15q.213 0 .356.144A.49.49 0 0 1 16 8.27q0 .212-.144.356a.48.48 0 0 1-.356.143zM.5 4a.48.48 0 0 1-.356-.144A.48.48 0 0 1 0 3.499q0-.212.144-.356A.49.49 0 0 1 .5 3h15q.213 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356A.48.48 0 0 1 15.5 4z"
  })));
};
export default SvgHamburger;